import {configureStore} from "@reduxjs/toolkit";
import {userReducer} from "./slices/userSlice";

const store = configureStore({
	reducer: {
		profile: userReducer
	}
})

export default store